import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Eyebrow, Section } from './layout';

/** Green-tick list used for proof points and offers. */
export function CheckList({ items }: { items: string[] }) {
  return (
    <ul className="m-0 flex list-none flex-col gap-3.5 p-0">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-3 text-base leading-[1.5] text-ink lg:text-[17px]">
          <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success-soft text-success-text">
            <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" />
          </span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

/**
 * Light stats band with the reference gym (anonymous: never its name or city).
 * Reads proof.eyebrow / number / numberLabel / title / items[] from the page namespace.
 */
export function ProofBand({ ns }: { ns: string }) {
  const { t } = useTranslation(ns);
  const items = t('proof.items', { returnObjects: true }) as string[];
  return (
    <Section className="border-y border-line bg-bg-public">
      <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-6">
        <div className="flex flex-col gap-4 lg:col-span-4">
          <Eyebrow>{t('proof.eyebrow')}</Eyebrow>
          <div className="font-display text-[48px] font-semibold leading-none tracking-[-0.03em] text-brand-500 lg:text-[64px]">
            {t('proof.number')}
          </div>
          <p className="m-0 text-base text-soft lg:text-lg">{t('proof.numberLabel')}</p>
        </div>
        <div className="flex flex-col gap-6 lg:col-span-7 lg:col-start-6">
          <p className="m-0 text-balance font-display text-[21px] font-semibold leading-[1.3] tracking-[-0.02em] text-ink lg:text-[27px]">
            {t('proof.title')}
          </p>
          <CheckList items={items} />
        </div>
      </div>
    </Section>
  );
}
